var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueryBuilder24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.99 2.00082C7.47 2.00037 2.99963 6.48 2.99918 12C2.99873 17.52 7.46836 22.0004 12.9884 22.0008C18.5184 22.0013 22.9987 17.5216 22.9992 12.0016C22.9996 6.48164 18.52 2.00127 12.99 2.00082ZM12.9985 20.0008C8.57852 20.0005 4.99882 16.4202 4.99918 12.0002C4.99954 7.58016 8.57984 4.00046 12.9998 4.00082C17.4198 4.00118 20.9995 7.58148 20.9992 12.0015C20.9988 16.4215 17.4185 20.0012 12.9985 20.0008ZM11.9996 7.00074L13.4996 7.00086L13.4992 12.2509L17.9989 14.9212L17.2488 16.1512L11.9991 13.0007L11.9996 7.00074Z",
    fill: "#1F437F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryBuilder24Px);
export default __webpack_public_path__ + "static/media/query_builder_24px.74a40a0605c047745e71e383d1ffe7af.svg";
export { ForwardRef as ReactComponent };